import axios from 'axios';
import url from './url';

const Api ={
    getProductos : async(pais,idcdz)=>{
        var urlMe = url + `/productos/catproductos/${pais}/${idcdz}`
        var opts = {
            method :'GET',
            mode : 'cors',
            cache : 'default', 
            headers :{
                'Content-Type': 'application/json',
                'Authorization' : localStorage.getItem("Authorization")
            }
        }
        return await axios.get(urlMe, opts)
    },
    getConsultaInventario: async (pais,codigo,qty,pedido,idcdz) => {         
        return await axios.get(url+`/productos/inventarios/${pais}/${codigo}/${qty}/${pedido}/${idcdz}`,
            {headers: {
                        'Content-Type': 'application/json'
                        ,'Authorization': localStorage.getItem("Authorization")
                    }
            }
        ) 
    },   
}
export default Api
